import moment from '@/moment-gp'

/* =============================================================================
DB:       Realtime DB
PATH:     goal.{goalId}.meta.tasks.{taskUUID}
          Maybe move to:
          goal.{goalId}.tasks.{taskUUID}
PURPOSE:  Stores events
============================================================================= */

export default {
  VALID_CHECKLIST_ITEM_STATES: ['completed', 'incomplete'],

  create({ userId }, data, BACKEND) {

    return {
      createdAt:          moment.currentTimeServer(BACKEND),
      createdBy:          userId,
      name:               data.name || "New task",
      deleted:            data.deleted || false,
      durationRemaining:  data.durationRemaining || 15 * 60, // in seconds
      durationDone:       data.durationDone || 0,       // in seconds
      sortidx:            data.sortirdx || data.sortidx || 100,
      deadline:           data.deadline || 0,
      finishedAt:         data.finishedAt || 0,
      description:        data.description || "",
      attachments:        data.attachments || [],
      label:              data.label || null,
      reward:             data.reward || null,
      jobstopper:         data.jobstopper || null,
      sessionId:          data.sessionId || null,
      // # IF backwardCompabilityPlantastic {
        level: data.level || 1,
        userMood: data.userMood || null,
        /*
        parent: parent_id,
        encrypted: false,
        priority: 1,
        progress: 0,
        status: 0,
        team: {},
        comments: {},
        timer: {},
        budget: {},
        userdata: {},
        */
      // # }
      // # IF backwardCompabilityMultiplayerLanes {
        isDaily: data.isDaily || false, // RAUS !!!
        // # IF isDaily {
        dailyAtFixedTime: data.dailyAtFixedTime || null, // RAUS !!!
        // # }
        isTemplate: data.isTemplate || false,
        // # IF isTemplate {
        // # } ELSE {
        done: data.done || false,
        // # }
      // # }
      // Alternative: List of Checklists (like Trello)
      laneId: data.laneId || null,      // Null means 'unassigned lane'

      /* Is this task only displayed inside a session and should therefor not be
         hidden on the kanban board */
      onlyExistsInsideSession: data.onlyExistsInsideSession || false,
      /*
        backwardCompabilityPlantastic       --> raus?
        backwardCompabilityMultiplayerLanes --> raus?
        done                                --> behalten!
      */
      hideCompletedItems: data.hideCompletedItems || false,
      sequenceItemId: data.sequenceItemId || null
    }
  },

  fields: {
    createdAt: { validate_bolt_type: 'ServerTimestamp' },
    createdBy: {},
    name: {},
    deleted: {},
    curation: {},
    durationRemaining: {},
    durationDone: {},
    sortidx: {},
    deadline: { validate_bolt_type: 'Timestamp' },
    description: {},
    level: {},
    isDaily: {},
    dailyAtFixedTime: {},
    isTemplate: {},
    done: {},
    laneId: {},
    onlyExistsInsideSession: {},
    userMood: {},
    hideCompletedItems: {},
    finishedAt: { validate_bolt_type: 'ServerTimestamp' },
    attachments: {},
    '/^attachments/[-_a-zA-Z0-9]+$/': {},
    label: {},
    jobstopper: {},
    reward: {},
    sessionId: { validate_bolt_type: 'AnyID' },
    sequenceItemId: { validate_bolt_type: 'AnyID' },
  }
};
